import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChartSquare = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1724 8C13.1724 6.89543 14.0678 6 15.1724 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8L15.1724 8V11.2632C15.1724 12.3677 14.277 13.2632 13.1724 13.2632H10.652V16C10.652 17.1046 9.75661 18 8.65204 18H5C4.44772 18 4 17.5523 4 17C4 16.4477 4.44772 16 5 16H8.65204V13.2632C8.65204 12.1586 9.54747 11.2632 10.652 11.2632H13.1724V8Z"
        />
      </svg>
    );
  }
);
